"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Checks if the given value is a Smithy structure of the given type.
 */

function isa(o) {
  var ids = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    ids[_i - 1] = arguments[_i];
  }

  return typeof o === "object" && ( // Checks for name after __type, as name is used instead for errors.
  "__type" in o && ids.indexOf(o["__type"]) > -1 || "name" in o && ids.indexOf(o["name"]) > -1);
}

exports.isa = isa;